import React from "react";
import { ButtonCtaFragment } from "types/graphql-types";
import * as styles from "./GenericBottomStickyBar.module.scss";
import { SectionContainer } from "@silversea-ssc/ui-components-react";
import PageBuilderButtonCTA from "components/PageBuilder/PageBuilderButtonCTA";
import { isPresent } from "src/utils/checks";
import { stringPresent } from "src/utils/strings";

type Props = {
  title?: string;
  content?: string;
  ctaButton?: ButtonCtaFragment;
};

const GenericBottomStickyBar: React.FC<Props> = ({
  title,
  content,
  ctaButton
}) => {
  return (
    <div className={styles.container}>
      <SectionContainer
        backgroundColor="titaniumDark"
        className={styles.wrapper}
      >
        <div className={styles.contentWrapper}>
          {stringPresent(title) && <div className={styles.title}>{title}</div>}
          {stringPresent(content) && <div>{content}</div>}
        </div>
        {isPresent(ctaButton) && (
          <div className={styles.ctas}>
            <PageBuilderButtonCTA
              {...ctaButton}
              size="small"
              mobileSize="small"
              full
            />
          </div>
        )}
      </SectionContainer>
    </div>
  );
};

export default GenericBottomStickyBar;
